import {
  CarListItem,
  IProductSoldArgs,
} from '@/typescript/interfaces/common.interface';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject, Subscription, interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
@Component({
  selector: 'app-confirm-sold-modal',
  templateUrl: './confirm-sold-modal.component.html',
  styleUrls: ['./confirm-sold-modal.component.scss'],
})
export class ConfirmSoldModalComponent implements OnChanges, OnDestroy {
  /** Controls modal visibility (bind this from the parent, e.g. via *ngIf or [isOpen]) */
  @Input() isOpen = false;

  /** Message shown to the user */
  @Input() actionMessage = '';

  /** Shows the ladda spinner on the confirm button while an action is processing */
  @Input() actionInProgress = false;

  /** Countdown duration in seconds before auto-confirm kicks in */
  @Input() autoConfirmSeconds = 10;

  /** Whether the countdown should auto-trigger the confirm action once it hits 0 */
  @Input() autoConfirmOnTimeout = true;

  /** List of cars shown in the modal */
  @Input() cars: CarListItem[] = [];

  /** Disabled All Button in the modal on api call */
  @Input() disabledAllBtn: boolean = false;

  // From Vehicle or Auction
  @Input() fromVehicle: boolean = false;

  // From Vehicle or Auction
  @Input() confirmLable = '';

  /** Emits when the user confirms (manually or via timeout) */
  @Output() confirmed = new EventEmitter<boolean>();

  /** Emits when the user cancels */
  @Output() cancelled = new EventEmitter<void>();

  /** Emits when the user cancels */
  @Output() productSold = new EventEmitter<IProductSoldArgs>();

  // $currentProductIdSub = new BehaviorSubject<string | null>(null);
  // currentProductId = this.$currentProductIdSub.asObservable();

  $loadingProductIdSub = new BehaviorSubject<string | null>(null);
  loadingProductId = this.$loadingProductIdSub.asObservable();

  secondsLeft = 0;

  private timerSub?: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cars']) {
      console.log(changes['cars'].currentValue, 'this.cars');
      const isAnyUnMarkRemain = (
        changes['cars'].currentValue as CarListItem[]
      )?.find((_c) => _c?.buyStatus === '0');

      if (!isAnyUnMarkRemain) {
        this.cancleAction();
      }
    }

    if (changes['isOpen']) {
      if (this.isOpen) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  private startTimer(): void {
    this.stopTimer(); // ensure no duplicate timers
    this.secondsLeft = this.autoConfirmSeconds;

    if (this.secondsLeft <= 0) {
      return;
    }

    this.timerSub = interval(1000)
      .pipe(takeWhile(() => this.secondsLeft > 0))
      .subscribe(() => {
        this.secondsLeft--;
        if (this.secondsLeft <= 0) {
          this.stopTimer();
          if (this.autoConfirmOnTimeout) {
            // this.autoConfirm();
          }
        }
      });
  }

  private stopTimer(): void {
    this.timerSub?.unsubscribe();
    this.timerSub = undefined;
  }

  /** Called automatically when the countdown reaches 0 */
  private autoConfirm(): void {
    this.confirmAction(true);
  }

  confirmAction(isAuto = false): void {
    this.stopTimer();
    this.confirmed.emit(isAuto);
  }

  cancleAction(): void {
    this.stopTimer();
    this.cancelled.emit();
  }

  // tooglecurrentProductId(value: string | null) {
  //   console.log('tooglecurrentProductId', value);
  //   this.$currentProductIdSub.next(value);
  // }

  onProductSold(productId: string) {
    console.log('onProductSold', productId);

    this.$loadingProductIdSub.next(productId);

    this.productSold.emit({
      productId,
      tooglecurrentProductId: (value) => {
        this.$loadingProductIdSub.next(value);
      },
    });
  }
}
